// extracted by mini-css-extract-plugin
export default {"ShrinkedColumn":"UsersTable_ShrinkedColumn__g7RkJ","TableHeader":"UsersTable_TableHeader__7Cg4u"};